//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  // i: Icono del button a izquierda.
  // iright: Icono del button a derecha.
  // variant: Clase css.
  //Para modal: dataTarget = data-target
  //Para modal: dataToggle = data-toggle
  //Para modal: dataBackdrop = data-backdrop
  name: "ActionButton",
  meta: {
    description: "Componente común de acciones personalizadas para botones",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  props: {
    id: {
      type: String,
      default: "",
      meta: {
        description: 'Id del Componente ActionButton',
        example: 'IdActionButton'
      }
    },
    variant: {
      type: String,
      default: "",
      meta: {
        description: 'Propiedad para definir estilos',
        example: 'outline-danger'
      }
    },
    type: {
      type: String,
      default: "button",
      meta: {
        description: 'Especifica la naturaleza del componente',
        example: 'button'
      }
    },
    text: {
      type: String,
      default: "",
      meta: {
        description: 'Propiedad para el texto',
        example: 'Texto requerido'
      }
    },
    classIcon: {
      type: String,
      default: "",
      meta: {
        description: 'Estilos para el icono',
        example: 'Texto requerido'
      }
    },
    i: {
      type: String,
      default: "",
      meta: {
        description: 'Icono del botón a la izquierda.',
        example: 'Texto requerido'
      }
    },
    iright: {
      type: String,
      default: "",
      meta: {
        description: 'Icono del botón a la derecha',
        example: 'Texto requerido'
      }
    },
    dataTarget: {
      type: String,
      default: "",
      meta: {
        description: 'Apunta a la identificación del modal',
        example: 'Texto requerido'
      }
    },
    dataToggle: {
      type: String,
      default: "",
      meta: {
        description: 'Abre la ventana modal',
        example: 'Texto requerido'
      }
    },
    dataBackdrop: {
      type: String,
      default: "",
      meta: {
        description: 'Especifica si el modal debe tener una superposición oscura',
        example: 'Texto requerido'
      }
    },
    minWidth: {
      type: String,
      default: () => ""
    },
    responsive: {
      type: Boolean,
      default: () => true
    }
  },
  methods: {
    click() {
      this.$emit("click");
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    staticClass: "ab-btn",
    class: _vm.variant + (_vm.responsive ? ' custom-class' : ''),
    style: {
      'min-width': _vm.minWidth
    },
    attrs: {
      "id": _vm.id,
      "type": _vm.type,
      "data-target": _vm.dataTarget,
      "data-toggle": _vm.dataToggle,
      "data-backdrop": _vm.dataBackdrop
    },
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }

        return _vm.click($event);
      }
    }
  }, [_vm.i ? _c('i', {
    staticClass: "mr-2",
    class: _vm.i + ' ' + _vm.classIcon,
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }

        return _vm.click($event);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _vm.iright ? _c('i', {
    staticClass: "pl-2",
    class: _vm.iright
  }) : _vm._e()], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-49c730ff_0", {
    source: "button[data-v-49c730ff]{color:#3f5b60;background-color:#fff;font-family:Lato,sans-serif;font-weight:500;font-size:1rem;text-align:center;border-radius:4px;border:1px solid #3f5b60;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;cursor:pointer;padding:5px;padding-left:10px;padding-right:10px;white-space:nowrap}.success[data-v-49c730ff]{color:#fff;background-color:#2db782;border-color:#2db782}.outline-success[data-v-49c730ff]{color:#2db782;background-color:#fff;border-color:#2db782;outline:0}.outline-success[data-v-49c730ff]:hover{color:#fff;background-color:#2db782}.danger[data-v-49c730ff]{color:#fff;background-color:#c9545e;border-color:#c9545e}.outline-danger[data-v-49c730ff],.outline-danger[data-v-49c730ff]:active{color:#c9545e;background-color:#fff;border-color:#c9545e;outline:0!important}.outline-danger[data-v-49c730ff]:hover{background-color:#c9545e;color:#fff}.warning[data-v-49c730ff]{color:#fff;background-color:#ffc107;border-color:#ffc107}.outline-warning[data-v-49c730ff]{color:#ffc107;background-color:#fff;border-color:#ffc107}.dark[data-v-49c730ff]{color:#fff;background-color:#3f5b60;border-color:#3f5b60}.outline-dark[data-v-49c730ff]{color:#3f5b60;background-color:#fff;border-color:#3f5b60}.success[data-v-49c730ff]:active,.success[data-v-49c730ff]:hover,.success[data-v-49c730ff]:link,.success[data-v-49c730ff]:visited{color:#fff;text-decoration:none;background-color:#2b9d71;border:1px solid #2b9d71}.success.focus[data-v-49c730ff],.success[data-v-49c730ff]:focus{outline:0;box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.success[data-v-49c730ff]:disabled{color:#fff;background-color:#aaa;border-color:#aaa;cursor:default}.danger[data-v-49c730ff]{font:Bold 16px/23px Lato}.no-padding[data-v-49c730ff]{padding-right:0!important}.orange[data-v-49c730ff]{background-color:#ff7058;color:#fff;border-color:#ff7058}.orange[data-v-49c730ff]:focus{outline:0}.transparent[data-v-49c730ff]{color:#3f5b60;background-color:#f4f6f3;border-color:#f4f6f3}.transparent[data-v-49c730ff]:focus{outline:0}@media all and (max-width:480px){.custom-class[data-v-49c730ff]{width:100%;display:block}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-49c730ff";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installActionButton(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('ActionButton', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
